const hasCustomImageLibrary = (organizationName?: string) => {
  switch (organizationName?.toLowerCase()) {
    case "comcast":
      return true;
    default:
      return false;
  }
};

export default hasCustomImageLibrary;
